// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s7yzQ","field":"styles_field__2Shwf","fieldCol":"styles_fieldCol__3QEro","diffCol":"styles_diffCol__3-DAw","diff":"styles_diff__1jLDw"};